export default "__VITE_ASSET__BlLtLqYC__"